module.exports = __webpack_public_path__ + "static/media/IMG_4259.e13e4897.PNG";